import * as React from 'react';
import { Button, ButtonSize } from '@cian/button-component';
import { GeoSuggest } from './geo_suggest';

import { getCookie } from '../../../../utils/cookie';
import { FOREVER_REGION_ID_COOKIE_KEY } from '../../constants';

import { IRegion } from '../../types';

import { getCurrentPosition } from './utils/get_current_position';
import { getRegionsByPoint } from './utils/get_regions_by_point';

import { Modal } from './modal';
import { Columns } from './columns';

const styles = require('./location_modal.css');

export interface ILocationModalProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onAcceptLocation(region: IRegion): any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClose(): any;
  popularCities?: IRegion[];
}

interface ILocationModalState {
  location?: IRegion;
  isTouchedSuggest: boolean;
}

export class LocationModal extends React.Component<ILocationModalProps, ILocationModalState> {
  public constructor(props: ILocationModalProps) {
    super(props);

    this.state = {
      isTouchedSuggest: false,
    };
  }

  public componentDidMount() {
    const hasForeverCookie = !!getCookie(FOREVER_REGION_ID_COOKIE_KEY);

    if (!hasForeverCookie) {
      this.tryGeolocation();
    }
  }

  public render() {
    return (
      <Modal onClose={this.props.onClose} modalClassName={styles['modal']}>
        <div className={styles['header']}>
          <div className={styles['title']}>Выберите регион или город</div>
          <div className={styles['control-bar']}>
            <GeoSuggest
              className={styles['suggest']}
              onSelect={this.handleSelectLocation}
              onSearchChange={this.handleSearchSuggest}
              selected={this.state.location}
            />
            <Button className={styles['button']} size={ButtonSize.S} onClick={this.handleAcceptLocation}>
              Выбрать
            </Button>
          </div>
        </div>
        {this.renderBody()}
      </Modal>
    );
  }

  private renderBody() {
    const { popularCities } = this.props;

    if (!popularCities) {
      return null;
    }

    return (
      <div className={styles['body']}>
        <div className={styles['city-tabs']}>
          {popularCities.slice(0, 10).map(city => (
            <a key={city.id} href="#" className={styles['city-tab']} onClick={this.bindCityClickHandler(city)}>
              {city.displayName}
            </a>
          ))}
        </div>
        <Columns items={popularCities} columns={4} renderItem={this.renderColumnCityItem} />
      </div>
    );
  }

  private renderColumnCityItem = (city: IRegion) => (
    <div key={city.id} className={styles['city-item']}>
      <a href="#" className={styles['city-link']} onClick={this.bindCityClickHandler(city)}>
        {city.displayName}
      </a>
    </div>
  );

  private bindCityClickHandler = (city: IRegion) => (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    this.handleSelectLocation(city);
  };

  private handleSearchSuggest = () => {
    if (this.state.isTouchedSuggest) {
      return;
    }

    this.setState({
      isTouchedSuggest: true,
    });
  };

  private handleSelectLocation = (geoItem: IRegion) => {
    this.setState({
      location: geoItem,
      isTouchedSuggest: true,
    });
  };

  private handleAcceptLocation = () => {
    const { location } = this.state;

    if (!location) {
      return;
    }

    this.props.onAcceptLocation(location);
  };

  private tryGeolocation = async () => {
    const { coords } = await getCurrentPosition();

    if (this.state.isTouchedSuggest) {
      return;
    }

    const regions = await getRegionsByPoint({
      lat: coords.latitude,
      lng: coords.longitude,
    });
    const region = regions[0];

    if (region && !this.state.isTouchedSuggest) {
      this.handleSelectLocation(region as IRegion);
    }
  };
}
